import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Cuándo recibo el material?',
  a: 'Inmediatamente. A los 2 minutos de confirmar el pago te llega un mail con el link de descarga directa. No hay esperas ni procesos manuales.'
}, {
  q: '¿Funciona para mi rubro?',
  a: 'Si vendés servicios como profesional independiente en Argentina, sí. Diseñadores, contadores, abogados, coaches, marketers, arquitectos, psicólogos, consultores, técnicos, fotógrafos, nutricionistas y más. Si cobrás por tu tiempo o conocimiento, el sistema aplica.'
}, {
  q: '¿Tengo que saber de marketing o de ventas?',
  a: 'No. El manual está escrito para que lo entienda alguien que nunca estudió marketing ni ventas. Todo está explicado en lenguaje humano, paso a paso, con ejemplos del mercado argentino.'
}, {
  q: '¿Y si no me sirve?',
  a: 'Tenés 7 días de garantía total. Si sentís que no valió lo que pagaste, te devolvemos el 100% sin preguntas ni formularios.'
}, {
  q: '¿En cuánto tiempo veo resultados?',
  a: 'Depende de cuánto ejecutés. Hay personas que mandan los primeros mensajes el mismo día que compran y tienen conversaciones abiertas en 48 horas. El plan completo está diseñado para 30 días pero los primeros resultados se ven en la primera semana.'
}, {
  q: '¿Es un curso con videos?',
  a: 'No. Es un PDF de implementación inmediata más los bonos en PDF. Lo leés en una tarde y empezás a aplicar esa misma noche. Sin plataformas, sin logins, sin accesos que vencen.'
}, {
  q: '¿Tengo que tener muchos seguidores o una base de clientes grande?',
  a: 'No. El sistema empieza con lo que ya tenés: tus contactos actuales de WhatsApp, tus ex-clientes y las personas que alguna vez te pidieron un presupuesto. Con 15 contactos ya podés arrancar.'
}, {
  q: '¿Esto funciona si mi rubro está muy complicado?',
  a: 'El manual está diseñado específicamente para el contexto argentino de consumo bajo. No es una guía genérica importada. Habla de inflación, del comprador argentino en modo supervivencia y de cómo moverte en ese contexto específico.'
}];
export const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 bg-cream" data-id="element-107">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-108">
        <div className="text-center mb-16" data-id="element-109">
          <h2 className="text-3xl sm:text-4xl font-bold text-neutral-900 mb-4" data-id="element-110">
            Preguntas frecuentes
          </h2>
        </div>

        <div className="space-y-4" data-id="element-111">
          {faqs.map((faq, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-white border border-neutral-200 rounded-xl overflow-hidden shadow-sm" data-id="element-112">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-113">
                <span className="font-bold text-neutral-900 text-lg pr-8 flex items-start gap-3" data-id="element-114">
                  <span className="text-brand-600" data-id="element-115">❓</span> {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-neutral-400 transition-transform duration-300 flex-shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-116" />
              </button>
              <AnimatePresence data-id="element-117">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-118">
                    <div className="p-6 pt-0 text-neutral-600 text-lg leading-relaxed border-t border-neutral-100 mt-2" data-id="element-119">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
};